import { Component, OnDestroy, OnInit,Input } from '@angular/core';
import { Location } from '@angular/common'
import { ActivatedRoute, Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { ErrorCodesData, strengthAsset } from '../../services/equipment.model';
import { EquipmentService } from '../../services/equipment.service';
import { PageTitleService } from '../../services/page-title.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { ESupportType, SuperFooterService } from 'src/app/core/services/super-footer.service';

@Component({
  selector: 'app-product-info',
  templateUrl: './product-info.component.html',
  styleUrls: ['./product-info.component.scss']
})
export class ProductInfoComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  asset: strengthAsset;
  assetCardio: any;
  assetName: string;
  serviceTickets: any;
  filteredTickets: any;
  hasFullPermission: boolean = false;
  enableEdit: boolean = false;
  isCardio: boolean;

  openedId: any = null;
  openedTasks: any = [];
  //variable to track if user needs service for indiviual equipment
  rowsPerPage: any = 5;
  currentPage: number = 1;
  pages: number[] = [];
  perPages: number[] = [0, 5, 10, 20];

  isFirstAvailable: boolean = false;
  isPrevAvailable: boolean = false;
  isLastAvailable: boolean = false;
  isNextAvailable: boolean = false;
  isPaginationAvailable: boolean = true;
  showPreventivePlan = false;
  visibleErrorCode: ErrorCodesData;
  allErrorCode: ErrorCodesData;
  rows: number = 0;
  sub = new Subscription();
  private _assetId: string | any;
  private _currentFacility: FacilityObject;
  errorCodesDesc = '';

  constructor(    
    public commonUtil: CommonUtil,
    private _rootScopeService: RootScopeService,
    private _facilityService: FacilityService,
    private _route: ActivatedRoute,
    private _cUtil: CommonUtil,
    private _toast: HaloToastService,
    private _equipmentService: EquipmentService,
    private _loader: HaloLoaderService,
    private location: Location,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private supportService: SuperFooterService,
    private _router: Router,
    ) { }

  ngOnInit(): void {
    this._assetId = this._route.snapshot.paramMap.get('assetId');
    this.isCardio = this._route.snapshot.paramMap.get('cardio') === 'true' ? true : false;
    const rootScopeSub = this._rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
    });
    this.sub.add(rootScopeSub);
    this._currentFacility = this._facilityService.selectedFacility();
    const facilityChanges = this._facilityService.selectedFacilitySource.subscribe((res) => {
      if(this._currentFacility.facilityId != res.facilityId) {
        this.location.back();
      }
    });
    this.sub.add(facilityChanges);
    if(this._currentFacility.summary.isPlanetFitness === "true"){
      this.getErrorCodes();
    }    
    this.getAsset();
    this.calculatePagesAndButtons();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  async getErrorCodes() {
    this.allErrorCode =  await this._equipmentService.getErrorCodes(this._currentFacility.facilityId, this._assetId);
    this.visibleErrorCode = {...this.allErrorCode};
  }
  

  async getAsset() {
    if(!this._currentFacility?.facilityId || false) return;
    //@ts-ignore
    this.asset = null;
    this.hasFullPermission = this._currentFacility['summary'].userRights.facility === 'F' ? true : false;
    try {
      this._loader.startProcess();
      if (this.isCardio) {
        this.assetCardio = await this._equipmentService.getCardioProductDetails(this._assetId);
        this.assetName = this.assetCardio.displayName;
        this.errorCodesDesc = this.commonUtil.replaceValueAsHTMLOnTranslatedText('ERROR.CODE.DESC', [this.commonUtil.translateText('EQ.TYPE.'+ this.assetCardio.activityId + '.SINGULAR')]);
        this.serviceTickets = await this._equipmentService.getServiceRequests(this._assetId, this._currentFacility.facilityId);
        this.calculatePagesAndButtons();
      } else {
        this.asset = await this._equipmentService.getEquipmentDetails(this._currentFacility.facilityId, this._assetId);
        this.assetName = this.asset.nickName;
        this.errorCodesDesc = this.commonUtil.replaceValueAsHTMLOnTranslatedText('ERROR.CODE.DESC', [this.commonUtil.translateText('EQ.TYPE.'+ this.asset.activityId + '.SINGULAR')]);
      }
    } catch (error) {
      console.error('API failed');
    }
    finally {
      this._loader.endProcess();
      this._cUtil.scrollTop();
    }
  }

  rename() {
    this.enableEdit = true;
  }

  cancelEdit() {
    this.enableEdit = false;
    if (this.isCardio) {
      this.assetName = this.assetCardio.displayName;
    } else {
      this.assetName = this.asset.nickName;
    }
    this.rootScopeData.isPageHasUnsavedChanges = false;
  }

  update() {
    this.enableEdit = false;
    this._loader.startProcess();
    this.rootScopeData.isPageHasUnsavedChanges = false;
    this._amplitudeAnalytics.logEvent({elementName: 'Update Name', action: 'Submit'});
    this._equipmentService.nameEquipment(this._currentFacility.facilityId, this._assetId, this.assetName, this.isCardio ? 'cardio' : 'strength', '',this._assetId,this._assetId)
      .subscribe(
        res => {
          if (this.isCardio) {
            this.assetCardio.displayName = this.assetName;
          } else {
            this.asset.nickName = this.assetName;
          }
          this._toast.creatToast(this.commonUtil.translateText('UPDATED.EQUIPMENT'));
          this._loader.endProcess();
        },
        err => {
          if (this.isCardio) {
            this.assetName = this.assetCardio.displayName;
          } else {
            this.assetName = this.asset.nickName;
          }
          console.error(err);
          this._loader.endProcess();
        }
      );
  }

  gotoService() {
    window.location.href = "halo.html#/service?assetId=" + this._assetId;
  }
  
  onRequestSupport() {
    this.supportService.switchForm(ESupportType.TECHNICIAN_VISIT);
  }

  nameChanged(evt: any) {
    this.rootScopeData.isPageHasUnsavedChanges = true;
  }

  showTicketTasks(ticket: any) {
    if (this.openedId === ticket.serviceReqNumber) {
      this.openedId = null;
      this.openedTasks = [];
    } else {
      this.openedId = ticket.serviceReqNumber;
      this.openedTasks = Object.values(ticket.tasks).sort((el1: any, el2: any) => { return el2.date - el1.date || -1 });
    }
  }

  paginationChanged() {
    if (parseInt(this.rowsPerPage) !== 0) {
      this.filteredTickets = this.serviceTickets.filter((ticket: any, i: number) => { return (i + 1) > ((this.currentPage - 1) * this.rowsPerPage) && (i + 1) <= (this.currentPage * this.rowsPerPage) });
    } else {
      this.filteredTickets = this.serviceTickets;
    }
  }

  calculatePagesAndButtons() {
    this.rows = this.serviceTickets ? this.serviceTickets.length : 1;
    this.currentPage = 1;
    if (this.rowsPerPage < 1) {
      this.isPaginationAvailable = false;
    } else {
      this.isPaginationAvailable = true;
      let _pagesLength = Math.ceil(this.rows / this.rowsPerPage);
      this.pages = [...Array(_pagesLength)].map((_, i) => 1 + i);

      if (_pagesLength > 2) {
        this.isFirstAvailable = true;
        this.isPrevAvailable = true;
        this.isLastAvailable = true;
        this.isNextAvailable = true;
      } else {
        this.isFirstAvailable = false;
        this.isPrevAvailable = false;
        this.isLastAvailable = false;
        this.isNextAvailable = false;
      }
    }

    this.paginationChanged();
  }

  setCurrentPage(_currentPage: number) {
    this.currentPage = _currentPage;
    this.paginationChanged();
  }

  goToFirst() {
    this.setCurrentPage(1);
  }

  goToPrev() {
    let _page = this.pages[this.currentPage - 2];
    if (_page) {
      this.setCurrentPage(_page);
    }
  }

  goToNext() {
    let _page = this.pages[this.currentPage];
    if (_page) {
      this.setCurrentPage(_page);
    }
  }

  goToLast() {
    this.setCurrentPage(this.pages[this.pages.length - 1]);
  }

  rowsPerPageChanged() {
    this.currentPage = 1;
    this.calculatePagesAndButtons();
  }

  stopBubbling(e: Event) {
    e.stopPropagation();
  }

  paginationErrorCodesChanged($event: any) {
    if($event.rowsPerPage === 0) {
      this.visibleErrorCode.errorCodeDetails = { ...this.allErrorCode.errorCodeDetails};
    } else {
      const start = ($event.currentPage - 1) * $event.rowsPerPage;
      const tmp = [...this.allErrorCode.errorCodeDetails];
      const end = start + $event.rowsPerPage - 1 > tmp.length ? tmp.length : $event.rowsPerPage;
      this.visibleErrorCode.errorCodeDetails = tmp.slice(start, end);
    }

  }
}
